import { useEffect, useState } from "react";
import { X } from "lucide-react";

import "./CategoryForm.css";

const initialForm = {
    name: "",
    slug: "",
    description: "",
    icon: "",
    image: "",
    color: "#A0001C",
    sortOrder: 0,
    isActive: true,
    isFeatured: false,
    isPopular: false,
};

function CategoryForm({
    category,
    addCategory,
    updateCategory,
    reload,
    onClose,
}) {

    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        if (category) {

            setForm({
                ...initialForm,
                ...category,
            });

        }

    }, [category]);

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.name.trim()) {

            alert("Category Name is required.");

            return;

        }

        try {

            setLoading(true);

            if (category) {

                await updateCategory(
                    category._id,
                    form
                );

            } else {

                await addCategory(form);

            }

            reload();

            onClose();

        } catch (error) {

            console.error(error);

            alert("Failed to save category.");

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="category-modal">

            <div className="category-modal-content">

                <div className="category-modal-header">

                    <h2>

                        {category
                            ? "Edit Category"
                            : "Add Category"}

                    </h2>

                    <button onClick={onClose}>

                        <X size={20} />

                    </button>

                </div>

                <form
                    onSubmit={handleSubmit}
                    className="category-form"
                >

                    <div className="form-grid">

                        <div className="form-group">

                            <label>

                                Category Name *

                            </label>

                            <input
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Slug

                            </label>

                            <input
                                name="slug"
                                value={form.slug}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Icon URL

                            </label>

                            <input
                                name="icon"
                                value={form.icon}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Banner Image URL

                            </label>

                            <input
                                name="image"
                                value={form.image}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Theme Color

                            </label>

                            <input
                                type="color"
                                name="color"
                                value={form.color}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="form-group">

                            <label>

                                Sort Order

                            </label>

                            <input
                                type="number"
                                name="sortOrder"
                                value={form.sortOrder}
                                onChange={handleChange}
                            />

                        </div>

                    </div>

                    <div className="form-group">

                        <label>

                            Description

                        </label>

                        <textarea
                            rows="4"
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="checkbox-group">

                        <label>

                            <input
                                type="checkbox"
                                name="isActive"
                                checked={form.isActive}
                                onChange={handleChange}
                            />

                            Active

                        </label>

                        <label>

                            <input
                                type="checkbox"
                                name="isFeatured"
                                checked={form.isFeatured}
                                onChange={handleChange}
                            />

                            Featured

                        </label>

                        <label>

                            <input
                                type="checkbox"
                                name="isPopular"
                                checked={form.isPopular}
                                onChange={handleChange}
                            />

                            Popular

                        </label>

                    </div>

                    <div className="modal-actions">

                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={onClose}
                        >

                            Cancel

                        </button>

                        <button
                            type="submit"
                            className="save-btn"
                            disabled={loading}
                        >

                            {loading
                                ? "Saving..."
                                : category
                                ? "Update Category"
                                : "Add Category"}

                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

}

export default CategoryForm;